export default __webpack_public_path__ + "static/hero_pinkPhase-f3b528c3e3233d6c74695449369676c6.mp4";